import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../auth/Context/AuthContext';
import axios from '../../adapters/API/axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import NavbarComponent from '../../component/Navbar';
import { Button, Col, Container, Row } from 'react-bootstrap';
import ModalTambahDivisi from '../../component/Modal/ModalTambahDivisi';
import { GoPencil } from 'react-icons/go';
import { MdDelete, MdGroups } from 'react-icons/md';
import ModalEditDivisi from '../../component/Modal/ModalEditDivisi';
import { AgGridReact } from 'ag-grid-react';
import {
    AllCommunityModule,
    ModuleRegistry,
    colorSchemeLightCold,
    themeQuartz
} from 'ag-grid-community';
import { useMediaQuery } from 'react-responsive';

function Divisi() {

    const isMobile = useMediaQuery({ maxWidth: 767 });

    const { tokens } = useContext(AuthContext);
    const [listGrup, setListGroup] = useState([]);
    const tokenUser = tokens?.token;
    const navigate = useNavigate();

    const [showAddDivisi, setShowAddDivisi] = useState(false);
    const handleShowAddDivisi = () => {
        setShowAddDivisi(true);
    }

    const [showEditDivisi, setShowEditDivisi] = useState(false);
    const [idSelected, setIdSelected] = useState()
    const handleShowAEditDivisi = (row) => {
        setShowEditDivisi(true);
        setIdSelected(row)
    }

    useEffect(() => {
        if (tokenUser !== undefined) fetchListDivisi()
    }, [tokenUser]);

    const fetchListDivisi = () => {
        axios.get(`/api/groups/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {
                let filteredArray = res.data.filter(item => item.name !== 'superuser');
                setListGroup(filteredArray);
            }).catch(err => {

                if (err.response?.status === 401) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                        confirmButtonText: 'Login',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate('/');
                        }
                    });

                } else (console.log(err))
            })
    };

    const handleDelete = async (rowId) => {
        const result = await Swal.fire({
            title: 'Apakah anda yakin ingin menghapus divisi ini?',
            text: 'Kamu tidak dapat mengembalikan data divisi ini!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus divisi ini!',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {
            try {

                const responseDelete = await axios.delete(`/api/groups/${rowId}`, {
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        withCredentials: true,
                        Authorization: `Token ${tokens?.token}`,
                    },
                });
                // console.log( responseDelete )
                Swal.fire('Terhapus!', 'Divisi berhasil dihapus.', 'success');
                fetchListDivisi();
            } catch (err) {
                console.log(err);
                Swal.fire('Error', 'Terjadi kesalahan saat menghapus!', 'error');
            }
        } else {

            Swal.fire('Dibatalkan', 'Divisi belum terhapus.', 'info');
        }
    };

    ModuleRegistry.registerModules([AllCommunityModule]);

    const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);

    const [rowData, setRowData] = useState([]);

    useEffect(() => {
        if (listGrup && listGrup.length > 0) {
            setRowData(listGrup);
        }
    }, [listGrup]);


    const colDefs = [
        {
            field: "name",
            headerName: 'Nama Divisi',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.name}
                    </div>
                );
            },
        },
        {
            field: "name",
            headerName: 'Nama',
            sort: 'asc',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "left",
                            justifyContent: "left",
                            cursor: "pointer",
                        }}
                    >
                        {row?.data?.name}
                    </div>
                );
            },
        },
        {
            field: "ubah",
            headerName: 'Ubah',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleShowAEditDivisi(row?.data)}
                    >
                        <GoPencil
                            size={20}
                            style={{ cursor: 'pointer' }}
                        />
                    </div>
                );
            },
        },
        {
            field: "hapus",
            headerName: 'Hapus',
            width: 100,
            pinned: 'right',
            cellRenderer: (row) => {
                return (
                    <div
                        style={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                        }}
                        onClick={() => handleDelete(row?.data?.id)}
                    >
                        <MdDelete
                            size={20}
                            style={{ cursor: 'pointer', color: 'red' }}
                        />
                    </div>
                );
            },
        },
    ];

    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true
    };

    const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

    useEffect(() => {
        const updateHeight = () => {
            setTableHeight(window.innerHeight - 200); // Adjust as needed
        };

        window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }, []);

    return (
        <>
            {/* <NavbarComponent /> */}
            <div>
                <Button
                    id='actionButtonTabel'
                    variant='btn'
                    style={{ color: 'white', fontSize: '14px' }}
                    onClick={handleShowAddDivisi}
                >
                    Tambah <MdGroups size={15} />
                </Button>
            </div>
            <div style={{ height: tableHeight }}>
                <AgGridReact
                    theme={themeLightCold}
                    rowData={rowData}
                    columnDefs={colDefs}
                    defaultColDef={defaultColDef}
                    pagination={isMobile ? false : true}
                    rowHeight={25}
                />
            </div>
            <ModalTambahDivisi
                showAddDivisi={showAddDivisi}
                setShowAddDivisi={setShowAddDivisi}
                fetchListDivisi={fetchListDivisi}
            />
            <ModalEditDivisi
                showEditDivisi={showEditDivisi}
                setShowEditDivisi={setShowEditDivisi}
                fetchListDivisi={fetchListDivisi}
                idSelected={idSelected}
            />
        </>
    )
}

export default Divisi
